export default "__VITE_ASSET__xhV8ZdyP__"